import RejectProposalModal from "./RejectProposalModal";
export default RejectProposalModal;
